import React from 'react';

import DateRangePicker from '@dashboard/components/DateRangePicker';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dashboard/components/ui/select';
import { dateRangeUnits } from '@dashboard/scenes/Dashboard/date-ranges';

const UNIT_LABELS = [
  [dateRangeUnits.HOUR, 'Hourly'],
  [dateRangeUnits.DAY, 'Daily'],
  [dateRangeUnits.WEEK, 'Weekly'],
  [dateRangeUnits.MONTH, 'Monthly'],
  [dateRangeUnits.YEAR, 'Yearly'],
];

/** The date range picker and unit select, driven by useStatisticsRange. */
export default function StatisticsRangeControls({
  statisticsRange,
  hasSubscription = false,
  billingPeriodStart = null,
  billingPeriodEnd = null,
}) {
  const {
    range,
    unit,
    setRange,
    setUnit,
    dateStart,
    dateEnd,
    setCustomStartDate,
    setCustomEndDate,
    availableUnits,
  } = statisticsRange;

  return (
    <div className="flex items-center justify-end gap-2">
      <DateRangePicker
        value={range}
        onChange={setRange}
        startDate={dateStart}
        endDate={dateEnd}
        onDateChange={(start, end) => {
          setCustomStartDate(start);
          setCustomEndDate(end);
        }}
        className="w-auto"
        hasSubscription={hasSubscription}
        billingPeriodStart={billingPeriodStart}
        billingPeriodEnd={billingPeriodEnd}
      />

      <Select value={unit} onValueChange={setUnit}>
        <SelectTrigger className="w-28" aria-label="Group by">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {UNIT_LABELS.filter(([value]) => availableUnits.includes(value)).map(([value, label]) => (
            <SelectItem key={value} value={value}>
              {label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
